/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Action__InstructionsInputs */

const en_header_action__instructions = /** @type {(inputs: Header_Action__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German: Handeln`)
};

/**
* | output |
* | --- |
* | "German: Handeln" |
*
* @param {Header_Action__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_action__instructions = /** @type {((inputs?: Header_Action__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Action__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_action__instructions(inputs)
});